import React from "react";
import { siteConfig } from "../siteConfig";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display font-black text-lg mb-3" style={{ color: siteConfig.colors.dark }}>{title}</h2>
    <div className="text-gray-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

const TermsPage = () => (
  <>
    <section className="pt-32 pb-10" style={{ backgroundColor: siteConfig.colors.dark }}>
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <h1 className="font-display font-black text-white" style={{ fontSize: "clamp(1.75rem,4vw,2.75rem)" }}>Terms of Service</h1>
        <p className="mt-2 text-white/50 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
      </div>
    </section>

    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <Section title="Acceptance of Terms">
          <p>
            By accessing and using this website, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.
          </p>
        </Section>

        <Section title="Use of Website">
          <p>This website is provided for informational purposes. You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of others.</p>
        </Section>

        <Section title="Services and Estimates">
          <p>
            Submitting a contact or quote form does not constitute a binding contract. All estimates are subject to on-site assessment and formal written proposal. {siteConfig.businessName} reserves the right to decline any project.
          </p>
        </Section>

        <Section title="Intellectual Property">
          <p>
            All content on this website, including text, images, logos, and graphics, is the property of {siteConfig.businessName} and may not be reproduced without prior written permission.
          </p>
        </Section>

        <Section title="Limitation of Liability">
          <p>
            {siteConfig.businessName} shall not be liable for any indirect, incidental, or consequential damages arising from your use of this website or reliance on information contained herein.
          </p>
        </Section>

        <Section title="Third-Party Links">
          <p>
            Our website may contain links to third-party websites. We have no control over and assume no responsibility for the content or practices of any third-party websites.
          </p>
        </Section>

        <Section title="Changes to Terms">
          <p>
            We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about these Terms may be directed to{" "}
            <a href={`mailto:${siteConfig.email}`} style={{ color: siteConfig.colors.primary }} className="font-medium">{siteConfig.email}</a>.
          </p>
        </Section>
      </div>
    </section>
  </>
);

export default TermsPage;
